import { create } from 'zustand';
import { persist } from 'zustand/middleware';
function getSystemTheme() {
    if (typeof window === 'undefined')
        return 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
export function resolveThemeMode(mode) {
    return mode === 'system' ? getSystemTheme() : mode;
}
export const useThemeStore = create()(persist((set, get) => ({
    appearance: 'dark',
    resolvedAppearance: 'dark',
    setAppearance: (appearance) => set({
        appearance,
        resolvedAppearance: resolveThemeMode(appearance),
    }),
    setResolvedAppearance: (resolvedAppearance) => set({ resolvedAppearance }),
    toggleAppearance: () => {
        const next = get().resolvedAppearance === 'dark' ? 'light' : 'dark';
        set({ appearance: next, resolvedAppearance: next });
    },
}), {
    name: 'prototype-theme',
    partialize: (state) => ({ appearance: state.appearance }),
    onRehydrateStorage: () => (state) => {
        if (state) {
            state.resolvedAppearance = resolveThemeMode(state.appearance);
        }
    },
}));
